import {service} from '../common/request.js';
 
export function getQuizHouse(data) {
  return service({
		url: '/app/question-bank/list',
		method: 'GET',
		data
	})
}

export function getCleanRecord(data) {
	return service({
		url: '/app/question-bank/clearExerciseRecord',
		method: 'GET',
		data
	})
}

export function getQuestionIdList(data) {
	return service({
		url: '/app/question/getExerciseQuestionList',
		method: 'GET',
		data
	})
}

export function getQuestionById(data) {
	return service({
		url: '/app/question/getExerciseQuestionById',
		method: 'GET',
		data
	})
}

export function getQuestionByIds(data) {
	return service({
		url: '/app/question/getExerciseQuestionByIds',
		method: 'GET',
		data
	})
}

export function postExerciseAnswer(data) {
	return service({
		url: '/app/exercise-answer',
		method: 'POST',
		data
	})
}

export function getErrorsIdList(data) {
	return service({
		url: '/app/question/getExerciseErrorQuestionList',
		method: 'GET',
		data
	})
}

export function getExamIdIdList(data) {
	return service({
		url: '/app/question/getPaperQuestionList',
		method: 'GET',
		data
	})
}

export function getExamListByIds(data) {
	return service({
		url: '/app/question/getPaperQuestionByIds',
		method: 'GET',
		data
	})
}

export function postExamAnswer(data) {
	return service({
		url: '/app/student-answer',
		method: 'POST',
		data
	})
}

export function postEndExam(data) {
	return service({
		url: '/app/paper-student/endExam',
		method: 'POST',
		data
	})
}

export function postAgainExam(data) {
	return service({
		url: '/app/paper-student/againExam',
		method: 'POST',
		data
	})
}